import { render } from "./homeHead.vue?vue&type=template&id=309874b6&scoped=true"
import script from "./homeHead.vue?vue&type=script&lang=js"
export * from "./homeHead.vue?vue&type=script&lang=js"

import "./homeHead.vue?vue&type=style&index=0&id=309874b6&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309874b6"]])

export default __exports__